export const DEFAULT_CONSTANT_TEXT: string = "";
export const APP_DISPLAY_NAME:string = 'My Gullak';
export const MONTH_ARRAY: string[] = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const APP_PRIMARY_COLOR: string = "#057156";
export const APP_SECONDARY_COLOR: string = "#71ddbe";
